import { FormGroup } from '@components/molecules/form/FormGroup';
import ReactSelect, { SelectOption } from '@components/atoms/ReactSelect';
import React from 'react';
import { SingleValue, MultiValue, ActionMeta } from 'react-select';
import { Refresh } from '@mui/icons-material';
import { Button } from '@components/atoms/Button';
import { useTranslation } from '@hooks/useTranslation';

interface ProjectFilterProps {
  selectedProject: { value: string; label: string } | null;
  projectOptions: { value: string; label: string }[];
  onProjectChange: (option: { value: string; label: string } | null) => void;
  onRefresh: () => void;
  isRefreshing?: boolean;
}

export const ProjectFilter: React.FC<ProjectFilterProps> = ({
  selectedProject,
  projectOptions,
  onProjectChange,
  onRefresh,
  isRefreshing = false,
}) => {
  const tDashboard = useTranslation('dashboard');
  const handleChange = (
    value: SingleValue<SelectOption> | MultiValue<SelectOption>,
    actionMeta: ActionMeta<SelectOption>,
  ) => {
    onProjectChange(value as { value: string; label: string } | null);
  };

  return (
    <div className="mb-6">
      <div className="flex items-center justify-end gap-4">
        <div className="w-full">
          <FormGroup label={tDashboard.filterByProject} htmlFor="projectSelect">
            <ReactSelect
              isClearable
              value={selectedProject}
              options={projectOptions}
              placeholder={tDashboard.allProjects}
              onChange={handleChange}
            />
          </FormGroup>
        </div>
        <Button
          className="mt-7"
          variant="tertiary"
          size="lg"
          onClick={onRefresh}
          disabled={isRefreshing}
          leftIcon={<Refresh sx={{ fontSize: '16px' }} />}>
          {tDashboard.refresh}
        </Button>
      </div>
    </div>
  );
};
